import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
  failureaddQuestionSubType,
  successaddQuestionSubType,
} from "./AddQuestionSubTypeSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { IQuestionSubType } from "../../../Pages/QuestionSubType/IQuestionSubType";

import {
  failuredeleteQuestionSubType,
  successdeleteQuestionSubType,
} from "./DeleteQuestionSubTypeSlice";
import {
  failurelistQuestionSubType,
  successlistQuestionSubType,
} from "./ListQuestionSubTypeSlice";
import {
  failureQuestionSubTypelist,
  successQuestionSubTypelist,
} from "./QuestionSubTypelistSlice";
import {
  failureEditQuestionSubType,
  successEditQuestionSubType,
} from "./EditQuestionSubTypeSlice";

// list
const ListQuestionSubTypeApi = (action: PayloadAction<IQuestionSubType>) => {
  return api.post("/api/questionType/", action.payload);
};

export function* ListQuestionSubTypeCall(
  action: PayloadAction<IQuestionSubType>
) {
  try {
    const response: AxiosResponse = yield call(ListQuestionSubTypeApi, action);
    yield put(successlistQuestionSubType(response.data));
  } catch (error) {
    yield put(failurelistQuestionSubType(error));
  }
}
const QuestionSubTypelistApi = () => {
  return api.get("/api/questionType/questiontype");
};

export function* QuestionSubTypelistCall(
  action: PayloadAction<IQuestionSubType>
) {
  try {
    const response: AxiosResponse = yield call(QuestionSubTypelistApi);
    yield put(successQuestionSubTypelist(response.data));
  } catch (error) {
    yield put(failureQuestionSubTypelist(error));
  }
}

// add
const AddQuestionSubTypeApi = (action: PayloadAction<IQuestionSubType>) => {
  return api.post("/api/questionType/subtype", action.payload);
};

export function* AddQuestionSubTypeCall(
  action: PayloadAction<IQuestionSubType>
) {
  try {
    const response: AxiosResponse = yield call(AddQuestionSubTypeApi, action);
    yield put(successaddQuestionSubType(response.data));
  } catch (error) {
    yield put(failureaddQuestionSubType(error));
  }
}

// edit
const EditQuestionSubTypeApi = (action: PayloadAction<IQuestionSubType>) => {
  return api.put("/api/questionType/update-subtype/", action.payload, {
    params: { id: action.payload.id },
  });
};

export function* EditQuestionSubTypeCall(
  action: PayloadAction<IQuestionSubType>
) {
  try {
    const response: AxiosResponse = yield call(EditQuestionSubTypeApi, action);
    yield put(successEditQuestionSubType(response.data));
  } catch (error) {
    yield put(failureEditQuestionSubType(error));
  }
}

// delete
const DeleteQuestionSubTypeApi = (action: PayloadAction<number>) => {
  return api.delete("/api/questionType/delete-subtype/", {
    params: { id: action.payload },
  });
};

export function* DeleteQuestionSubTypeCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(
      DeleteQuestionSubTypeApi,
      action
    );
    yield put(successdeleteQuestionSubType(response.data));
  } catch (error) {
    yield put(failuredeleteQuestionSubType(error));
  }
}
